export const buyerSideMenuItem=
[{
    "userRole":"tech_buyer",
    "menuName":"Home",
    "isActive":"true",
    "path":"/tech-buyer",
    "imageUrl" : 'assets/images/sidebar-icons/home.svg'
  },
  {
    "userRole":"tech_buyer",
    "menuName":"My Research",
    "isActive":"true",
    "path":"/tech-buyer/my-research-list",
    "imageUrl" : 'assets/images/sidebar-icons/research.svg'
  },
  {
    "userRole":"tech_buyer",
    "menuName":"My Bookmarks",
    "isActive":"true",
    "path":"/tech-buyer/my-bookmarks",
    "imageUrl" : 'assets/images/sidebar-icons/bookmark.svg'
  },
  {
    "userRole":"tech_buyer",
    "menuName":"My Connections",
    "isActive":"true",
    "path":"/tech-buyer/my-connections",
    "imageUrl" : 'assets/images/sidebar-icons/connections.svg'
  },
  {
    "userRole":"tech_buyer",
    "menuName":"My Social",
    "isActive":"true",
    "path":"/tech-buyer/social-feeds",
    "imageUrl" : 'assets/images/sidebar-icons/social.svg'
  },
  {
    "userRole":"tech_buyer",
    "menuName":"Messages",
    "isActive":"true",
    "path":"/tech-buyer/messages",
    "imageUrl" : 'assets/images/sidebar-icons/message.svg'

  },
  {
    "userRole":"tech_buyer",
    "menuName":"My Meetings",
    "isActive":"true",
    "path":"/tech-buyer/my-meetings",
    "imageUrl" : 'assets/images/sidebar-icons/meetings.svg'
  // },
  // {
  //   "userRole":"tech_buyer",
  //   "menuName":"Notifications",
  //   "isActive":"true",
  //   "path":"/tech-buyer/notifications",
  //   "imageUrl" : 'assets/images/sidebar-icons/notifications.svg'
  },  {
    "userRole":"tech_buyer",
    "menuName":"Vendor Assesment Tool",
    "isActive":"true",
    "path":"/tech-buyer/vendor-assessment-tool",
    "imageUrl" : 'assets/images/sidebar-icons/Vat-Icon.svg'
  }
  ];



// WEBPACK FOOTER //
// ./src/app/shared/constants/tech-buyer-side-menu.ts